export function getBaseUrl() {
  const protocol = location.protocol === 'https:' ? 'https:' : 'http:'
  const host = `${protocol}//${window.location.host}`
  return host
}

export function getProtocol() {
  return location.protocol === 'https:' ? 'https:' : 'http:'
}